import axios from "axios";
import { msalInstance } from "../index"
import { billingRequest } from "../authConfig";

axios.interceptors.request.use(
    async (config) => {
        const accounts = msalInstance.getAllAccounts()

        try {
            const { accessToken } = await msalInstance.acquireTokenSilent({
                ...billingRequest,
                account: accounts[0]
            });

            if (accessToken) {
                config.headers = {
                    authorization: `Bearer ${accessToken}`
                };
            }
        } catch (error) {
            console.log(error)
        }

        return config;
    },
    (error) => Promise.reject(error)
);

var windowUrl = window.location.hostname.toLowerCase();
var billingUrl = "";

if (windowUrl==="franchise-pricing-secure.hrblock.ca")
{
    billingUrl = "billingsecure.hrblock.ca";
}
else if (windowUrl==="franchise-price-settings.hrblock.ca")
{
    billingUrl = "billing-azure-prd.hrblock.ca";
}
else if (windowUrl.startsWith("franchise-pricing-secure"))
{
    billingUrl = windowUrl.replace("franchise-pricing-secure", "billingsecure");
}
else if(windowUrl==="localhost")
{
    //billingUrl = "localhost:5003";
    billingUrl = "billing-azure-qa-01.hrblock-qas.ca";
}
else
{
    billingUrl = windowUrl.replace("franchise-price-settings", "billing");
}

axios.defaults.baseURL = `https://${billingUrl}/api/`;